/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect,useState, useRef } from 'react'

import { getCSSVariableValue } from '../../../../assets/ts/_utils'
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import moment from 'moment'
type Props = {
  className: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
}

const Order: FC<Props> = ({
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const [selectedOption, setSelectedOption] = useState<string>('Select the devision'); // Initialize with 'Total' or any default option
  let [selectedData, setSelectedData] = useState<any>([]);
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // setSelectedOption(event.target.value);
    const selectedValue = event.target.value;
    console.log(selectedValue,"selectedOption");
    outletCoverd(selectedValue)
    setSelectedOption(selectedValue)
    
  };

  const outletCoverd = (selectedValue: string)=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    const raw = JSON.stringify({
      division:selectedValue,
    });

    console.log(raw,"raw");
    
  
    const requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
  
    fetch(`https://crm.romsons.com:8080/OutletCoverageWeb`, requestOptions)
      .then(response => response.text())
      .then(result => {
        let arr = JSON.parse(result)
        selectedData = arr.data;
        setSelectedData(selectedData);
        console.log(selectedData,"result");
      })
      .catch(error => console.log('error', error));
  }
  const currentDate = moment();
  const currentMonth = currentDate.format('MMMM-YYYY');

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
           

            <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>Outlet Coverage</span>

          
          </div>
          <span className='text-gray-400 pt-1 fw-semibold fs-6'>Division wise Information  </span>
          <span className='text-dark pt-1 fw-semibold fs-6'>  {currentMonth}</span>
        </div>
      </div>
      <select value={selectedOption} onChange={handleSelectChange}>
      <option value='Select the devision'>Select the devision</option>
              <option value='1'>Retail</option>
              <option value='2'>MSD</option>
              <option value='3'>KAD</option>
              <option value='6'>OPS</option>
              <option value='7'>GOVT</option>
              <option value='5'>GTD</option>
              {/* Add more options as needed */}
            </select>

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
      

        <div className='d-flex flex-column content-justify-center flex-row-fluid'>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Total</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'> {selectedData[0]?.TotalActive !== null ? selectedData[0]?.TotalActive : 'null'}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Covered</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{selectedData[0]?.covered !== null ? selectedData[0]?.covered : 'null'}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-warning me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Missed</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{selectedData[0]?.missed !== null ? selectedData[0]?.missed : 'null'}</div>
          </div>
       
          
        
        </div>
      </div>
    </div>
  )
}



export { Order }
